
//schema validation Puestos
import * as yup from "yup";

export const PuestosSchema = yup.object().shape({
  name: yup.string().required("Ingresa el nombre de la razón social"),
});

